import { useCallback } from 'react'

/**
 * Returns a resolver that turns a Firebase Storage object path into a
 * downloadable URL, used to preview invitation attachments in the plan
 * wizard. Mirrors the resolver the view-hunt-plan screen passes to
 * HuntDetailPage. The Storage SDK is imported lazily so it stays out of the
 * synchronous bundle path — the click that triggers resolution is async
 * anyway.
 */
export function useResolveHuntAttachmentUrl() {
  return useCallback(async (storagePath: string): Promise<string> => {
    const { getStorage, ref, getDownloadURL } = await import('firebase/storage')
    return getDownloadURL(ref(getStorage(), storagePath))
  }, [])
}
